<template>
    <div>
        <div class="mb-20">
            <v-row align="end">
                <v-col cols="12" lg="auto" class="mb-10 mb-lg-0">
                    <h5 class="bar-text d-flex align-center">
                        지점 소개 <span class="color-grey-7 page-text--sm d-inline-block ml-10 ml-lg-20 font-weight-regular">전국의 지점을 만나다</span>
                    </h5>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" lg="auto">
                    <v-row justify="end" class="row--x-small">
                        <v-col cols="9" sm="10" md="auto">
                            <v-text-field class="w-100 min-w-md-300px" v-model="filter.searchValue" placeholder="검색어를 입력하세요." hide-details outlined @keydown.enter="() => { search(true); }" >
                            </v-text-field>
                        </v-col>
                        <v-col cols="3" sm="2" md="auto">
                            <v-btn @click="search()" class="h-100 w-100 w-md-100px color-white" color="grey-7">검색</v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
        <div class="pt-12 pt-lg-36 border-top border-color-black border-2 w-100">
            <div class="interview-slide interview-slide2">
                <v-btn x-large icon outlined color="grey-d" class="slide-btn slide-btn-next"><i class="icon icon-right-arrow-dark"></i></v-btn>
                <v-btn x-large icon outlined color="grey-d" class="slide-btn slide-btn-prev"><i class="icon icon-left-arrow-dark"></i></v-btn>
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div v-for="interview, index in branchInterview" :key="index" class="swiper-slide">
                            <a :href="interview.meta.href" target="_blank" class="board-item d-block border border-color-light">
                                <div class="thumb-wrap">
                                    <div class="thumb" :style="`background-image: url(${interview.thumb})`"></div>
                                </div>
                                <div class="board-item__txt pa-20 px-md-22">
                                    <p class="page-text--sm board-item__txt__tit">
                                        {{interview.subject}}
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <v-item v-for="interview, index in branchInterview" :key="index">
            <v-card width="200">
                <a :href="interview.meta.href" target="_blank">
                    <v-img :src="interview.thumb"></v-img>
                </a>
                {{interview.subject}}
            </v-card>
        </v-item> -->
    </div>
</template>

<script>
import Swiper from "swiper/bundle";
import api from '@/api';

export default {
	components: {
    },
    data() {
        return {
            filter: {
                searchValue: this.$route.query.searchValue || "",
                code: "interview",
                'category': '지점 소개'
            },
            branchInterview: [],
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            let { boards } = await api.v1.boards.gets({ params: this.filter });
            this.branchInterview = boards;

            this.$nextTick(() => {

                this.Swiper = new Swiper('.interview-slide2 .swiper-container', {
                    spaceBetween: 12,
                    slidesPerView: 2,
                    centeredSlides: false,
                    speed: 500,
                    // loop: true,
                    // autoplay: {
                    //     delay: 5000,
                    //     disableOnInteraction: false,
                    // },
                    breakpoints: {
                        768:{
                            slidesPerView: 4,
                            spaceBetween: 12,
                        },
                        1024:{
                            slidesPerView: 4,
                            spaceBetween: 36,
                        },
                        1200:{          
                            slidesPerView: 4,
                            spaceBetween: 36,        
                            navigation: {
                                prevEl: '.interview-slide2 .slide-btn-prev',
                                nextEl: '.interview-slide2 .slide-btn-next',
                            },
                        }
                    },
                });
            });
        },
        async search() {
            let { boards}= await api.v1.boards.gets({ params: this.filter });
            
            this.branchInterview = boards;
        },
        view(interview) {
            this.$router.push(`${this.$route.path}/${interview._id}`);
        }
    }

}
</script>

<style>

</style>